import { useSiteMetadata } from "./site-medatata";

export const useSitefinityFooter = () => {
    const { sitefinityFooter } = useSiteMetadata();

    const result = JSON.parse(sitefinityFooter);

    return result;
} 